$(function () {
    $('.b2b-tiers input, .b2b-tiers textarea').blur(function () {
        let element = $(this);
        setTimeout(function () {
            if (element.val() == "") {
                element.siblings('.label-up').removeClass('goUp');
                element.removeClass('light-red');
            } else {
                element.siblings('.label-up').addClass('goUp');
            }
        });
    });

    $('.b2b-tiers .rfield').change(function () {
        if ($(this).val().trim().length === 0) {
            $(this).addClass('empty-field');
        } else {
            $(this).removeClass('empty-field');
            $(this).removeClass('light-red');
        }
    });

    $('.b2b-tiers button[type="submit"]').on('click', function (e) {
        e.preventDefault();
        const form = this.closest('form');

        $(form).find('.error-msg, .success-msg').hide();

        $(form).find('.empty-field').each(function (ind, element) {
            $(element).addClass('light-red');
        });

        if (!form.checkValidity()) {
            const firstInvalidField = form.querySelector(':invalid');
            if (firstInvalidField) {
                if (!isElementInViewport(firstInvalidField)) {
                    firstInvalidField.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
                setTimeout(function () {
                    firstInvalidField.focus({ preventScroll: true });
                    firstInvalidField.reportValidity();
                }, 750);
            }
            return;
        }

        let actionUrl = $(form).attr('data-shop-url') + '/a/early-rider/retailer-request';
        let emptyFieldSize = $(form).find('.empty-field');

        if (emptyFieldSize.length > 0) return false;

        const countrySelect = document.getElementById('b2b_country');
        const selectedOption = countrySelect.options[countrySelect.selectedIndex];
        const countryCode = selectedOption ? selectedOption.dataset.countryCode : '';

        const formData = new FormData(form);
        const data = Object.fromEntries(formData);
        data.country_code = countryCode;

        $.ajax({
            url: actionUrl,
            type: 'POST',
            data: JSON.stringify(data),
            processData: false,
            contentType: false,
            success: function (result) {
                $('html, body').animate({
                    scrollTop: $('.b2b-tiers-form').offset().top - 120
                }, 600);

                if (result && result.success === false && result.message) {
                    $(form)
                        .find('.error-msg')
                        .text(result.message)
                        .show();

                    return;
                }

                form.reset();
                $('.label-up').removeClass('goUp');
                $(form).find('.success-msg').show();
            },
            error: function (XMLHttpRequest, textStatus, result) {
                //console.log('error ', textStatus);
            },
            complete: function() {
                //console.log('complete');
            }
        });
    });

    function isElementInViewport(element) {
        const rect = element.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }
});